module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "st-sp",
    attrs: {
      "id": "intro"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fmh"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "sau-1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Rachel Caine")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("When I was growing up, I used to wonder why girls never got the cool stories. You know what I mean—the tales with knights fighting for right, with detectives prowling the mean streets to solve crimes, and the gritty stories about growing up on the wrong side of the tracks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Instead, the books people thought "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("I")]), _vm._v(" should read were about ballerinas. About good girls who did what they were told. About women who rarely had adventures, and when they did, rarely saved themselves, or anybody else.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I decided I didn’t want to be the princess languishing in the tower—I wanted to be the knight battling to save her. So I grabbed all the adventure stories I could, and never looked back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m particularly proud to be included in this collection of stories featuring powerful women, women who aren’t afraid to kick a little butt—or a lot of it—when the situation calls for it. I’m also honored to be in the company of these fantastic storytellers, who kick some stereotyping butt of their own.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m proud to be a chick—never more than now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Because chicks are awesome.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ee3c7f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/introduction.vue
// module id = 66
// module chunks = 0